import { render, staticRenderFns } from "./GetInquiryList.vue?vue&type=template&id=1d41ef1e&scoped=true&"
import script from "./GetInquiryList.vue?vue&type=script&lang=js&"
export * from "./GetInquiryList.vue?vue&type=script&lang=js&"
import style0 from "./GetInquiryList.vue?vue&type=style&index=0&id=1d41ef1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41ef1e",
  null
  
)

export default component.exports